import {
  parseApplePayDetails,
  parseApplePayToInternalStructure,
} from 'parsers/applePayParser/applePayParser';

/**
 * Maps wallet types to their corresponding internal structure parsing functions.
 *
 * - APPLE_PAY: Parses the payment method into the Apple Pay internal structure.
 * - GOOGLE_PAY: Currently returns an empty object (no implementation).
 */
export const walletInternalStructureMap = {
  APPLE_PAY: paymentMethod => parseApplePayToInternalStructure(paymentMethod),
  GOOGLE_PAY: () => {},
};

/**
 * Maps wallet types to their corresponding detail formatting functions.
 *
 * - APPLE_PAY: Formats the expiration date for Apple Pay.
 * - GOOGLE_PAY: Returns an empty string (no implementation).
 */
export const walletDetailsMap = {
  APPLE_PAY: ({ expiration }) => parseApplePayDetails(expiration),
  GOOGLE_PAY: () => '',
};
